import { privateApi } from '../config';

const endpoint = '/service-docs/v1/marcas';

export function list() {
  return privateApi.get(endpoint);
}
